import { render, staticRenderFns } from "./EMIDisplayBankList.vue?vue&type=template&id=2a0fa7e8&scoped=true&"
import script from "./EMIDisplayBankList.vue?vue&type=script&lang=js&"
export * from "./EMIDisplayBankList.vue?vue&type=script&lang=js&"
import style0 from "./EMIDisplayBankList.vue?vue&type=style&index=0&id=2a0fa7e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0fa7e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VListItem,VListItemContent,VRow})
